import decode from 'jwt-decode';

export const checkToken = () => {
    return  (localStorage.getItem('token') !== null) && decode(localStorage.getItem('token')).exp > Date.now() / 1000;
}

export const get_id = () => {
    return decode(localStorage.getItem('token')).uid
}